import Icon from "@ant-design/icons";
import { ReactComponent as RewardSvg } from "./svg/reward.svg";

const RewardIcon = (props) => <Icon component={RewardSvg} {...props} />;

export default RewardIcon;
